module.exports = __webpack_public_path__ + "static/media/rewind.c5f49c43.svg";